<template>
  <v-img
    src="https://cdn.vuetifyjs.com/images/cards/house.jpg"
    class="white--text align-end"
    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
    height="200px"
    @click="changeImage()"
  ></v-img>
</template>

<script>
export default {
  methods: {
    changeImage() {
      alert("change image");
    }
  }
};
</script>

<style>
</style>